import SentimentBadge from '@/features/Feedback/field/Sentiment/SentimentBadge';
import SentimentSelectModal from '@/features/Feedback/field/Sentiment/SentimentDropdown/SentimentSelectModal';
import { useElementRef } from '@/hooks/pure/useElementRef';
import useFeedbackListStore from '@/stores/Feedback/FeedbackListStore';
import useDropdownStore from '@/stores/pure/DropdownStore';
import { FeedbackSentiment } from '@/types/feedbackConst';

import { useFeedbackDetailContext } from '../../context/FeedbackDetailContext';
import { ValueWrapper } from '../ValueWrapper';
import { PropertyRowWrapper } from './PropertyRowWrapper';
import type { CommonFieldProps } from './types';

export const KeySentimentField = (
  props: CommonFieldProps & {
    feedback_alias: string;
    key_sentiment?: FeedbackSentiment;
  },
) => {
  const setCurrDropdown = useDropdownStore((state) => state.setCurrDropdown);
  const { elementRef: keySentimentElement, setElementRef } =
    useElementRef<HTMLDivElement>();

  const { updateDetail } = useFeedbackDetailContext();
  const changeSentiment = useFeedbackListStore(
    (state) => state.changeSentiment,
  );

  if (!props.showFull && !props.key_sentiment) return null;

  return (
    <PropertyRowWrapper {...props} expandable>
      <div className="flex flex-wrap gap-0.5">
        <ValueWrapper
          ref={setElementRef}
          onClick={() => setCurrDropdown('key_sentiment')}
        >
          <div className="flex gap-1.5">
            <SentimentBadge
              type={props.key_sentiment || FeedbackSentiment.NEUTRAL}
            />
          </div>
        </ValueWrapper>
      </div>
      <SentimentSelectModal
        selected={props.key_sentiment}
        feedbackKey={props.feedback_alias}
        name="key_sentiment"
        triggerEl={keySentimentElement}
        onSelect={(key) => {
          changeSentiment(props.feedback_alias, key as FeedbackSentiment);
          updateDetail({
            sentiment: key as FeedbackSentiment,
          });
        }}
      />
    </PropertyRowWrapper>
  );
};
